import ModalUpdateChatGroupPatients from "./ModalUpdateChatGroupPatients";

export default ModalUpdateChatGroupPatients;
